import ApolloClient from 'apollo-boost';

export default new ApolloClient({
    //uri: "http://54.144.246.245:4000/graphql",
  uri: "http://localhost:4000/graphql",

});
